import { useMutation } from "react-query";

import HttpClient from "../../httpClient";
import authManagerInstance from "../../auth";


const useLogin = () =>
  useMutation(
    ({ lastName, formattedDate, password }) =>
      HttpClient.memberLogin
      .post("/sign_in", {
        member: {
          date_of_birth: formattedDate,
          pii_last_name: encodeURIComponent(lastName),
          password,
        },
      }, {})
      .then((res) => res.data),
    {
      onError: () => {
      },
      onSuccess: (data) => {
        // console.log("setting user as ", data)
        authManagerInstance.setUser(data);
      },
    }
  );


export default useLogin;
